import React, { useState, useEffect } from 'react'
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { withStyles, createStyles } from '@mui/styles';
import ClipLoader from "react-spinners/ClipLoader";
import { CreateUrl, CallGetAPI, CallPutAPI, CallDeleteAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import moment from 'moment'
import DOMPurify from 'dompurify'
import Button from '@mui/material/Button';
import Modal from 'react-bootstrap/Modal'
import TextInputBox from '../../components/Comments/TextInputBox';
import TextField from '@mui/material/TextField';
import Loader from '../../Utils/Loader/NewLoader2025'


interface Props {
    classes: {
        cardTitleWhite: string;
        formControl: string;
        cardCategoryWhite: string;
    };
}


interface ReleaseNotesData {
    text: string
    startDate: Date 
    endDate: Date 
    id: number 
    portalVersion: string
}

interface TempNotes {
    text: string
    startDate: Date | null
    endDate: Date | null
    portalVersion: string
}

const styles: Record<any, any> = {
    formControl: {
        minWidth: 120,
    },
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        marginLeft: "20px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    }
};

const style = createStyles(styles);

const ReleaseNotes: React.FC<Props> = ({classes }) => {
    

    const [loading, setLoading] = useState<boolean>(true)
    const [releaseNoteData, setReleaseNoteData] = useState<string>("")
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const [portalVersion, setPortalVersion] = useState<string>("")
    const [modal, setModal] = useState<boolean>(false)
    const [tempRelease, setTempRelease] = useState<TempNotes>({ text: "", portalVersion: "", startDate: null, endDate: null })
    const [modalTitle, setModalTitle] = useState<string>("")
    const [edit, setEdit] = useState<boolean>(false)
    useEffect(() => {
        reloadData()
    }, [])

    const reloadData = ():void => {
        CallGetAPI(CreateUrl('/api/aquaguard/releasenotes'), {})
            .then((data:ReleaseNotesData) => {
                console.log(data)
                setLoading(false)
                setReleaseNoteData(DOMPurify.sanitize(data.text))
                setStartDate(data.startDate)
                setEndDate(data.endDate)
                setPortalVersion(data.portalVersion)
            })
    }
    const toggleModal = ():void => {
        setModal(!modal)
    }

    const handleCreateNew = ():void => {
        toggleModal()
        setModalTitle("New Release")
        setEdit(false)
    }
    const handleTextChange = (e): void => {
        const tempNotes = { ...tempRelease }
        tempNotes.text = e.value
        setTempRelease(tempNotes)

    }

    const handleEdit = ():void => {
        toggleModal()
        setModalTitle("Edit Release")
        setEdit(true)
        const editRelease = tempRelease
        editRelease.text = releaseNoteData
    }

    const handleCancelEvent = () => {
        toggleModal()
        setTempRelease({ text: "", portalVersion: "", startDate: null, endDate: null })
    }

    const submitReleaseNote = (): void => {


        if (!edit) {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    text: tempRelease.text,
                    portalVersion: tempRelease.portalVersion,
                    startDate: moment(),
                    endDate: null
                })
            }
            CallPostAPI(CreateUrl('/api/aquaguard/releasenotes'), requestOptions)
                .then(data => console.log(data))
            .catch (err => console.log(err))
        } else {
            const requestOptions = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    text: tempRelease.text,
                    portalVersion: tempRelease.portalVersion,
                    startDate: moment(),
                    endDate: null
                })
            }
            CallPutAPI(CreateUrl('/api/aquaguard/releasenotes'), requestOptions)
                .then(data => console.log(data))
                .catch(err => console.log(err))
        }
        toggleModal()
        setTimeout(() => reloadData(), 500)
        setTempRelease({ text: "", portalVersion: "", startDate: null, endDate: null })
    }

    const handlePortalVersionChange = (e) => {
        const change = { ...tempRelease }
        change.portalVersion = e.target.value
        setTempRelease(change)
    }


    return (<div>
        {loading &&
            <div style={{
                position: 'absolute', left: '50%', top: '50%',
                transform: 'translate(-50%, -50%)'
            }}>
                <Loader />
            </div>

        }
        {!loading && <div>
            <Modal
                show={modal}
                style={{

                    position: 'absolute', left: '50%', top: "50%",
                    transform: 'translate(-50%, -40%)',
                    zIndex: 1000000000
                }}
            >
                <Modal.Header>
                    <Modal.Title>{modalTitle}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TextField
                        label={"portal version"}
                        value={tempRelease.portalVersion}
                        onChange={handlePortalVersionChange}
                    />
                    <TextInputBox currentText={tempRelease.text} handleTextChange={(e): void => { handleTextChange(e) }} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="contained" style={{ marginRight: "10px" }} onClick={():void => submitReleaseNote()}>Save</Button>
                    <Button variant="contained" color="error" onClick={():void => handleCancelEvent() }>Cancel</Button>
                </Modal.Footer>
            </Modal>
            <GridContainer >
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary" className="view view-cascade  d-flex justify-content-between align-items-center py-2 mx-4 mb-3">
                            <h4 className={classes.cardTitleWhite}>Release Notes</h4>
                            
                        </CardHeader>
                        <CardBody>
                            <div style={{display: "flex", justifyContent: "space-between"} }>
                                <h4>Current Release Note</h4>
                                <div>
                                    <Button variant="contained" color="warning" style={{ marginRight: "10px" }} onClick={() => handleEdit() }>Edit</Button>
                                    <Button variant="contained" onClick={() => {handleCreateNew() }}>Create New</Button>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "center", }}>
                            <div style={{ display: "block", margin: "20px 0", border: "1px solid black", width: "50%", padding: "20px" }} dangerouslySetInnerHTML={{ __html: releaseNoteData }} />
                            </div>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>


        </div>}
    </div>)
}
export default withStyles(style)(ReleaseNotes)